import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { temaGeneral } from "./theme/paleta.js"
import App from './App.jsx'
import { AuthProvider } from './context/AuthContext.jsx'
import { FeedbackProvider } from './context/FeedbackContext.jsx'
import { ProspectosProvider } from './context/ProspectosContext.jsx'
import { NegociosProvider } from './context/NegociosContext.jsx'


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider theme={temaGeneral}>
      <CssBaseline />
      <AuthProvider><FeedbackProvider>
        <ProspectosProvider>
          <NegociosProvider>
            <App />
          </NegociosProvider>
        </ProspectosProvider>
      </FeedbackProvider></AuthProvider>
    </ThemeProvider>
  </StrictMode>,
)
